// Whether the tab is visible (not minimized or behind another tab).

import { useSyncExternalStore } from 'react';

const subscribe = (onChange: () => void) => {
  document.addEventListener('visibilitychange', onChange);
  return () => document.removeEventListener('visibilitychange', onChange);
};

const getSnapshot = () => document.visibilityState === 'visible';

export function useDocumentVisible(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot);
}
